import React from "react";
import PageNavHeader from "../PageNavHeader";

const headingStyle = { fontFamily: "Inter, sans-serif", fontWeight: 800, fontSize: "56px", lineHeight: "100%", letterSpacing: "-0.04em" };
const subtitleStyle = { fontFamily: "Inter, sans-serif", fontWeight: 400, fontSize: "28px", lineHeight: "100%", letterSpacing: "-0.04em", color: "#FFFFFF", maxWidth: "1307px" };

const DemoNavHeader = () => (
  <PageNavHeader>
    <h1 className="lowercase" style={headingStyle}>
      <span style={{ color: "#9747FF" }}>our demo </span>
      <span style={{ color: "#FFFFFF" }}>videos</span>
    </h1>
    <p className="lowercase mx-auto mt-10" style={subtitleStyle}>
      we simplify the way you do restaurant and retail business
    </p>
  </PageNavHeader>
);

export default DemoNavHeader;
